import { api } from '@/api/main.api'

export async function apiArchiveTask (projectId, taskId) {
  return api('post', `/v3/project/task/archive`, { projectId, taskId })
}

export async function apiUnArchiveTask (projectId, taskId) {
  return api('post', `/v3/project/task/unarchive`, { projectId, taskId })
}

export async function apiAssigneeDesigner (projectId, taskId, designerId) {
  return api('post', '/v3/project/assign-designer-on-task', {projectId, taskId, designerId})
}

export async function apiAddDesignsFileKeys (projectId, taskId, addedDesignsFileKeys) {
  return api('post', '/v3/project/task/addDesign', { projectId, taskId, addedDesignsFileKeys })
}

export async function apiAddChatFileKeys (projectId, chatFileKeys) {
  return api('post', '/v3/project/addChatFile', { projectId, chatFileKeys })
}

export async function apiRemoveDesignFileKey (projectId, taskId, removedDesignFileKey) {
  return api('post', '/v3/project/task/removeDesign', { projectId, taskId, removedDesignFileKey })
}

export async function apiUpdateStatus (projectId, taskId, taskStatus) {
  return api('post', '/v3/project/task/updateStatus', { projectId, taskId, taskStatus })
}

export async function apiUpdateTaskDeadline (projectId, taskId, deadline) {
  return api('post', '/v3/project/task/setOrUpdateTaskDeadline', { projectId, taskId, deadline })
}

export async function apiUpdatePriority (projectId, taskId, taskPriority) {
  return api('post', '/v3/project/task/updatePriority', { projectId, taskId, taskPriority })
}

export async function apiDesignerStartWorking (projectId, taskId) {
  return api('post', `/v3/project/${projectId}/task/${taskId}/start-working-on-task/`)
}

export async function apiUpdateEta (projectId, taskId, estimatedTimeOfCompletion, estimatedWork) {
  return api('post', '/v3/project/task/updateETA', { projectId, taskId, estimatedTimeOfCompletion, estimatedWork })
}

export async function apiDownloadAllDesigns (projectId, taskId) {
  return api('get', `/v3/project/${projectId}/task/${taskId}/zipDesign`)
}

export async function apiUpdateTask (param) {
  return api('post', '/v3/project/task', param)
}

export async function apiMarkAllAsSeen (projectId, taskId) {
  return api('post', '/v3/project/task/seen', { projectId, taskId })
}

export async function apiApproveStatus (projectId, taskId) {
  return api('post', `/v3/project/${projectId}/task/${taskId}/approve`)
}

export async function apiUpdateDesignFileOrder (projectId, taskId, designerFileList) {
  return api('post', '/v3/project/task/updateDesignFileOrder', { projectId, taskId, designerFileList })
}

export async function apiDesignSeen (projectId, taskId, designerFileKey) {
  return api('post', '/v3/project/task/designSeen', { projectId, taskId, designerFileKey })
}

export async function apiDesignCommentsSeen (projectId, taskId, designerFileUuid) {
  return api('post', '/comment/design/task/seen', { projectId, taskId, designerFileUuid })
}



// WEBPACK FOOTER //
// ./src/api/task.api.js